import React from "react";

import { copy } from "shared/assets";
import {
  Button,
  Modal,
  Message,
  ButtonContainer,
  Loader,
  APIErrorMessage,
} from "shared/components";
import { Spacer } from "shared/layout";
import { IAPIState, ITheme } from "shared/types";

const { form } = copy;

interface ConfirmModalProps {
  title?: string;
  icon?: React.ComponentType<any>;
  message: string;
  confirmButtonCopy: string;
  handleConfirm: () => void;
  handleClose: () => void;
  apiMeta?: {
    status: IAPIState;
    error?: any;
  };
}

export const ConfirmModal: React.FC<ConfirmModalProps> = ({
  title,
  icon,
  message,
  apiMeta,
  confirmButtonCopy,
  handleConfirm,
  handleClose,
}) => {
  return (
    <Modal title={title} icon={icon} handleClose={handleClose} data-testid="confirm_modal">
      <Spacer size="m">
        <Message hideBackground>{message}</Message>
        <ButtonContainer>
          <Button onClick={handleConfirm} data-testid="confirm_button">
            <Spacer spaceDirection="horizontal" size="xs">
              <span>{confirmButtonCopy}</span>
              {apiMeta?.status === IAPIState.pending && <Loader size="s" />}
            </Spacer>
          </Button>
          <Button
            onClick={handleClose}
            theme={ITheme.secondary}
            data-testid="cancel_confirm_button"
          >
            {form.cancel}
          </Button>
        </ButtonContainer>
        {!!apiMeta?.error && <APIErrorMessage apiErrorMessage={true} apiError={apiMeta?.error} />}
      </Spacer>
    </Modal>
  );
};
